import * as React from 'react';
import { connect } from 'react-redux';
import * as Fuse from 'fuse.js';
import { Card, Form, Notification } from '../';
import { addAccountToUser, clearErrors } from '../../redux/actions/users';
import { getAccounts } from '../../redux/actions/accounts';
import fields from '../../data/fields';
import search from '../../data/search';

interface Props {
  users: any;
  userId: number;
  dispatch: Function;
  accounts: Array<any>;
}

interface State {
  items: any;
  errorMessage: string | boolean;
}

class AccountForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.accounts,
      errorMessage: false,
    };
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  async componentDidMount() {
    await this.props.dispatch(clearErrors());
    await this.props.dispatch(getAccounts());
    this.setState({ items: this.props.accounts });
  }

  /**
   * When new props are received check if the accounts state
   * needs to be updated.
   */
  componentWillReceiveProps(newProps: Props) {
    if (this.props.accounts !== newProps.accounts) {
      this.setState({ items: newProps.accounts });
    }
  }

  /**
   * Search for the accounts
   */
  handleSearch(data) {
    if (data.search) {
      const fuse = new Fuse(this.props.accounts, search.accounts);
      this.setState({ items: fuse.search(data.search), errorMessage: false });
    } else {
      this.setState({ items: this.props.accounts, errorMessage: false });
    }
  }

  /**
   * Add an account to the user
   */
  async handleItemClick(account) {
    const response = await this.props.dispatch(
      addAccountToUser(this.props.userId, account.id),
    );
    if (!response.error) {
      this.setState({ errorMessage: false });
    } else {
      this.setState({ errorMessage: response.error });
    }
  }

  render() {
    return (
      <div>
        <Card list>
          <Form
            fields={fields.accounts.search}
            type="sites"
            handleChange={this.handleSearch}
            hasButton={false}
            disabled={this.props.users.isFetching}
          />
        </Card>
        {!this.props.users.isFetching &&
          this.props.users.didInvalidate && (
            <Card list>
              <Notification type="danger">
                {this.props.users.error}
              </Notification>
            </Card>
          )}
        {this.state.items.map((item) => (
          <Card
            list
            key={item.name}
            handleClick={() => {
              this.handleItemClick(item);
            }}
          >
            <strong>{item.name}</strong>
          </Card>
        ))}
        {this.state.items.length === 0 && (
          <Card list>
            <Notification type="default">No relevant sites found</Notification>
          </Card>
        )}
        {this.state.errorMessage && (
          <Card list>
            <Notification type="danger">{this.state.errorMessage}</Notification>
          </Card>
        )}
      </div>
    );
  }
}

const mapsStateToProps = ({ users, accounts }) => ({
  users,
  accounts: accounts.accounts,
});

export default connect(mapsStateToProps)(AccountForm);
